import React from 'react';
import {
  Box,
  Card, CardContent, createStyles,
  makeStyles,
  Typography,
} from '@material-ui/core';
import type { ICostCardProps } from './RepairCostInterfaces';

const useStyles = makeStyles(() => createStyles({
  estimatorCard: {
    height: '100%',
  },
  estimatorSvg: {
    height: 24,
    width: 24,
    marginBottom: 7,
  },
}));

const RepairCostTotalCard: React.FC<ICostCardProps> = (
  { cost },
) => {
  const classes = useStyles();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  const fixedCost = cost.toFixed(2);

  return (
    <Card className={classes.estimatorCard}>
      <CardContent>
        <Typography>{'Repair Cost'}</Typography>
        <Typography variant="h4" className="verticalCenter">
          <Box component="span" mr={1}>
            {'$'}
            {fixedCost}
          </Box>
        </Typography>
        <Typography variant="caption" color="textSecondary">{'USD'}</Typography>
      </CardContent>
    </Card>
  );
};

export default RepairCostTotalCard;
